// Selectors
export const getAuthNotPersisted = (state) => state.authNotPersisted;

export const getAuth = (state) => state.authToken;

export const getVerify = (state) => state.verify;
